import React from 'react';
import styled, { keyframes } from 'styled-components';
import { primaryM } from 'web-ui-kit/colors';

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var _templateObject, _templateObject2;

var VARIANTS = {
  "default": 'white',
  primary: primaryM
};

function ThreeQuarterCircle(_ref) {
  var className = _ref.className,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 14 : _ref$size,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'default' : _ref$variant;
  var fillColor = VARIANTS[variant];
  return (
    /*#__PURE__*/
    React.createElement("svg", {
      "aria-label": "in progress",
      className: className,
      "data-testid": "cta-spinner",
      width: size,
      height: size,
      viewBox: "0 0 14 14",
      fill: "none",
      role: "img",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.99999 12.6C3.9072 12.6 1.4 10.0928 1.4 6.99999C1.4 3.9072 3.9072 1.4 6.99999 1.4C10.0928 1.4 12.6 3.9072 12.6 6.99999H14C14 3.134 10.866 0 6.99999 0C3.134 0 0 3.134 0 6.99999C0 10.866 3.134 14 6.99999 14V12.6Z",
      fill: fillColor
    }),
    /*#__PURE__*/
    React.createElement("circle", {
      cx: "13.3001",
      cy: "6.9998",
      r: "0.699999",
      fill: fillColor
    }),
    /*#__PURE__*/
    React.createElement("circle", {
      cx: "7.00078",
      cy: "13.3001",
      r: "0.699999",
      fill: fillColor
    }))
  );
}

var spin = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  from { transform: rotate(0deg); }\n  to { transform: rotate(359deg); }\n"])));
var CtaSpinner = styled(ThreeQuarterCircle)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  animation: ", " 1s linear infinite;\n"])), spin);
export default CtaSpinner;